module.exports = __webpack_public_path__ + "static/citroen-f589a3844a591f9bd7c4d211229a304f.png";